import { LuCheck, LuCheckCheck } from 'react-icons/lu'
import Button from '../Buttons'
import { useState } from 'react'
import CompleteModal from '../Modals/Complete'
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react'
import { FEATURE_FLAGS } from '../../hooks/featureFlags'

const Complete = () => {
	const finalizeButtonFF = useFeatureFlagVariantKey(FEATURE_FLAGS.FINALIZE_BUTTON)
	const posthog = usePostHog()
	const [showCompleteModal, setShowCompleteModal] = useState(false)

	return (
		<>
			<CompleteModal open={showCompleteModal} closeModal={() => setShowCompleteModal(false)} />
			<Button
				type="default"
				onClick={() => {
					posthog.capture('complete-essay-click')
					setShowCompleteModal(true)
				}}
				className={`px-2 md:px-4 !py-1  ml-2`}
			>
				{LuCheck({ className: 'inline-block md:mr-2 mr-1 inline-block' })}
				{finalizeButtonFF === 'test' ? 'Finalize' : 'Complete'}
			</Button>
		</>
	)
}

export default Complete
